export default {
  product_info: 'Tuotetiedot',
  return: 'Palaa vaihtoehtoihin',
};
